import { Context, Effect, Layer } from 'effect';
import { GetTenants } from '../requests/clientInformation/tenants/requests';
import { GetTenantsResolver } from '../requests/clientInformation/tenants/resolvers';
import { HttpService } from './http';
export class FetchTenantsError {
    originalError;
    _tag = 'GetTenantsError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export class ParseTenantsError {
    _tag = 'ParseTenantsError';
}
export const ClientInformation = Context.GenericTag('@services/ClientInformation');
export class ClientInformationConfig extends Context.Tag('@fixtuur/backpack/ClientInformationConfig')() {
}
export const layer = Layer.effect(ClientInformation, Effect.gen(function* () {
    const http = yield* HttpService;
    const config = yield* ClientInformationConfig;
    const getTenants = () => Effect.gen(function* (_) {
        return yield* _(Effect.request(GetTenants({}), GetTenantsResolver(http, config.clientInfoUrl)));
    });
    return { getTenants };
}));
